import { Body, Button, FlexBox, Headline } from '@Backlot-Cars/archie';
import OktaService from 'helpers/okta';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { BannerContainer } from './styles';

const OktaExistingSessionBanner = ({
	queryParamsToForward,
	redirectAfterLogin,
	redirectToAfcFastPath,
	setError,
	show,
	setShowOktaExistingSessionBanner,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [userProfile, setUserProfile] = useState({});
	const { t } = useTranslation('signin');

	const checkExistingSession = async () => {
		const { isActiveSession, userProfile } = await OktaService.getInstance().checkSession();
		setShowOktaExistingSessionBanner(isActiveSession);
		setUserProfile(userProfile);
	};

	const loginWithOktaForExistingSession = async () => {
		setIsLoading(true);
		const { success, afcOktaFastPath } = await OktaService.getInstance().generateNewCodeForActiveSessions({
			queryParamsToForward,
		});
		if (afcOktaFastPath) {
			redirectToAfcFastPath(userProfile);
			return;
		}
		if (success) {
			redirectAfterLogin();
		} else {
			setShowOktaExistingSessionBanner(false); // hide the banner
			setError(t(`okta.signedIn.existingSignInFailed`));
		}
		setIsLoading(false);
	};

	useEffect(() => {
		checkExistingSession();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (show) {
		return (
			<FlexBox flexDirection="column" gap="md" margin={['48px', 0, '36px', 0]}>
				<BannerContainer>
					<Headline size="H4">{t(`okta.signedIn.alreadySignedIn`)}</Headline>
					<FlexBox justifyContent="space-between" alignItems="center" gap="sm">
						<FlexBox flexDirection="column" gap="xs" flex={1} justifyContent="center">
							<Body bold size="largest">
								{userProfile.firstName} {userProfile.lastName}
							</Body>
							<Body color="secondary" size="largest">
								{userProfile.email}
							</Body>
						</FlexBox>
					</FlexBox>
					<Button onClick={loginWithOktaForExistingSession} disabled={isLoading} width="100%">
						{`${t('okta.signedIn.continueAs')} ${userProfile.firstName}`}
					</Button>
				</BannerContainer>

				<Button variant="link" onClick={() => setShowOktaExistingSessionBanner(false)}>
					{t(`okta.signedIn.notYou`)}
				</Button>
			</FlexBox>
		);
	}
};

export default OktaExistingSessionBanner;
